module.exports = __webpack_public_path__ + "img/banner-referral-new.7d7a461a.png";